<!--
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-19 15:07:17
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-29 14:38:08
 * @FilePath: /wemeet-admin-new/src/views/recruitment/talent/TalentBank.vue
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
-->
<template>
  <div class="talent-bank">
    <el-form inline @submit.prevent="query(1)">
      <el-form-item label="真实姓名">
        <el-input v-model="queryParams.name" clearable placeholder="请输入真实姓名" @change="query(1)" />
      </el-form-item>
      <el-form-item label="手机号码">
        <el-input v-model="queryParams.phone" clearable placeholder="请输入手机号码" @change="query(1)" />
      </el-form-item>
      <el-form-item label="入库时间">
        <el-date-picker
          v-model="queryParams.dateRange"
          end-placeholder="结束时间"
          range-separator="至"
          start-placeholder="开始时间"
          type="daterange"
        />
      </el-form-item>
      <el-form-item>
        <el-button icon="search" type="primary" @click="query()">查询</el-button>
        <el-button icon="refresh" type="warning" @click="reset">重置</el-button>
        <el-button icon="download" type="primary" @click="downloadExcel()">导出报表</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table v-loading="loading" border :data="tableData" :table-layout="'auto'">
      <el-table-column label="头像" width="76">
        <template #default="{ row }">
          <el-image :src="row.avatar" style="width: 50px; height: 50px" />
        </template>
      </el-table-column>
      <el-table-column label="真实姓名" prop="name" />
      <el-table-column label="手机号码" prop="phone" />
      <el-table-column label="入库时间" prop="crateTime" />
      <el-table-column label="最近投递时间" prop="jobTime" />
      <el-table-column label="岗位信息" prop="jobName" />
      <el-table-column align="center" label="操作">
        <template #default="{ row }">
          <el-link type="primary" :underline="false" @click="showDetail(row)">查看详情</el-link>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-model:current-page="queryParams.pageNum"
      background
      layout="prev, pager, next"
      :page-size="queryParams.pageSize"
      :total="queryParams.total"
      @current-change="query"
    />

    <!-- 推荐人详情 -->
    <TalentDetail :id="detailModal.id" :visible="detailModal.visible" @close="handleDetailClose" />

    <!-- 导出 -->
    <ExportDrawer
      :data="exportDrawerData"
      title="人才信息库报表导出"
      :visible="exportDrawerVisible"
      @close="closeExportDrawer"
      @refresh="refreshExcel"
    />
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted, watchEffect } from 'vue'
  import { omit } from 'lodash'
  import { getTalentList } from '@/api/recruitment'
  import { exportType } from '../context'
  import TalentDetail from './TalentDetail.vue'
  import { useExportDrawer } from '@/hooks/useExportDrawer'
  import ExportDrawer from '@/components/ExportDrawer.vue'
  import { parseTime } from '@/utils'

  const defaultQueryParams = {
    name: '',
    phone: '',
    startTime: '',
    endTime: '',
    dateRange: [],
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }

  const queryParams = reactive({ ...defaultQueryParams })

  const loading = ref(false)
  const tableData = ref([])

  watchEffect(() => {
    const [start, end] = queryParams.dateRange
    if (start) queryParams.startTime = parseTime(start, '{y}-{m}-{d}')
    if (end) queryParams.endTime = parseTime(end, '{y}-{m}-{d}')
  })

  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...omit(queryParams, 'total', 'dateRange'),
      pageNum,
    }

    loading.value = true

    getTalentList(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list, total } = data
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function reset() {
    for (const k in defaultQueryParams) {
      queryParams[k] = defaultQueryParams[k]
    }
    query(1)
  }

  onMounted(() => {
    query()
  })

  const detailModal = reactive({
    visible: false,
    data: null,
  })

  function showDetail(row) {
    detailModal.id = row.id
    detailModal.visible = true
  }

  function handleDetailClose() {
    detailModal.visible = false
    detailModal.id = -1
  }

  const {
    visible: exportDrawerVisible,
    data: exportDrawerData,
    generateExcel,
    refreshExcel,
    close: closeExportDrawer,
  } = useExportDrawer()

  function downloadExcel() {
    const type = exportType.ENTERPRISE_USER_JOB
    const params = {
      type,
      relationType: type,
      ...omit(queryParams, 'pageNum', 'pageSize', 'total', 'dateRange'),
    }
    generateExcel(params)
  }
</script>

<style lang="scss" scoped>
  .talent-bank {
    padding: 16px;
  }
</style>
